// #512: Lage des Assistenten-Knopfs aus den Benutzer-Einstellungen
// (`assistent.position`). Eigene Datei, damit der Einstellungs-Dialog nicht den
// ganzen Chat mitlädt.
export function assistentPosition(einstellungen) {
  return einstellungen?.assistent?.position === 'links' ? 'links' : 'rechts';
}
